import { CLASS_NAMES } from "../classnames";
import { iconStyleFromStyleBlock } from "./utils";
import type { GeneratedTheme } from "../types";

export const generateIconStyles = (iconStyles: GeneratedTheme["icon"]) => {
  return `
        .${CLASS_NAMES.ICON} {
            ${iconStyleFromStyleBlock(iconStyles.default)}
        }   
    `;
};
